import { FormControlLabel, Switch, FormHelperText, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';
import React from 'react';

import { ProductsList } from './ProductsList';
import { useStyles } from './styles';

import type { FormValues } from '../constants';

function ChangePlan() {
  const { setFieldValue, values, handleChange, errors } = useFormikContext<FormValues>();

  const classes = useStyles();
  const plans = values.plan_changeconfig;

  function handleSelectPlan(planId: number) {
    const updatedPlans = plans.map((plan) => {
      if (plan.plan_id === planId) {
        return { ...plan, selected: !plan.selected };
      }
      return plan;
    });
    setFieldValue('plan_changeconfig', updatedPlans);
  }

  function handleSelectAllPlans(isVariation = false) {
    const filteredPlans = plans.filter((plan) => plan.variation === isVariation);
    const isSelected = filteredPlans.every((plan) => plan.selected);
    const updatedPlans = plans.map((plan) => {
      if (filteredPlans.some((filteredPlan) => filteredPlan.plan_id === plan.plan_id)) {
        return { ...plan, selected: !isSelected };
      }
      return plan;
    });
    setFieldValue('plan_changeconfig', updatedPlans);
  }

  const handleSelectAllVariations = () => handleSelectAllPlans(true);
  const sameProductPlans = plans.filter((plan) => !plan.variation);
  const variationsPlans = plans.filter((plan) => plan.variation);

  return (
    <div>
      <Typography variant='h6'>Troca de plano</Typography>
      <div className={classes.content}>
        <div>
          <p>Você pode habilitar ou desabilitar a troca de plano para este produto</p>
          {errors.plan_changeconfig && <FormHelperText error>{errors.plan_changeconfig}</FormHelperText>}
        </div>
        <div>
          <FormControlLabel
            label='Permitir troca de plano entre planos do mesmo produto'
            control={
              <Switch
                id='change-plan-same-product-switch'
                color='primary'
                name='allows_plan_change_for_product'
                checked={values.allows_plan_change_for_product}
                onChange={handleChange}
              />
            }
          />
          <FormHelperText>Uma vez habilitado o cliente poderá efetuar a troca de plano para os planos deste produto</FormHelperText>
        </div>
        {values.allows_plan_change_for_product && (
          <ProductsList data={sameProductPlans} handleSelectPlan={handleSelectPlan} handleSelectAllPlans={handleSelectAllPlans} />
        )}
        <div>
          <FormControlLabel
            label='Permitir troca de plano entre planos de variações do produto'
            control={
              <Switch
                id='change-plan-variations-switch'
                color='primary'
                name='allows_plan_change_for_variation'
                checked={values.allows_plan_change_for_variation}
                onChange={handleChange}
              />
            }
          />
          <FormHelperText>Uma vez habilitado o cliente poderá efetuar a troca deste plano para os planos de outra variação</FormHelperText>
        </div>
        {values.allows_plan_change_for_variation && (
          <ProductsList data={variationsPlans} handleSelectPlan={handleSelectPlan} handleSelectAllPlans={handleSelectAllVariations} displayProduct />
        )}
      </div>
    </div>
  );
}

export { ChangePlan };
